<template>
  <page :name="$t('Documenti utili')" :description="$t('Qui puoi trovare tutti i documenti e moduli utili')" :empty-text="$t('Nessun documento disponibile')">
    <document-list v-if="contracts.length" :title="$t('Condizioni Contrattuali')" :documents="contracts" :label="$t('Visualizza')" />

    <document-list v-if="login.is_reseller && partner.length" :title="$t('Partner program')" :documents="partner" :label="$t('Scarica')" />

    <document-list v-if="billing.length" :title="$t('Modulistica amministrativa')" :documents="billing" :label="$t('Scarica')" />

    <document-list v-if="other.length" :title="$t('Altri moduli')" :documents="other" :label="$t('Scarica')" />
  </page>
</template>

<style lang="scss" scoped>
@media (min-width: 992px) {
  .list-view-pf-description {
    width: 100%;
  }
}
</style>

<script setup lang="ts">
import { $t as _t } from '@/i18n';
import { useLoginStore } from '@/store/login';
import { computed } from 'vue';
import DocumentList, { type Document } from '../components/document-list.vue';

const login = useLoginStore();

const billing = computed(() => {
  const billing: Document[] = [];

  if (login.fatturante.strid === 'dhh') {
    billing.push({
      name: _t('Cambio azienda di fatturazione di un servizio'),
      description: _t(
        'Documento per gestire il cambio di fatturazione dei servizi da inviarci compilato in tutte le sue parti e firmato da entrambe le aziende coinvolte.',
      ),
      link: 'https://files.artera.net/s/WFBREYMaT8ZbEMR',
    });

    billing.push({
      name: _t('Modifica del registrante di un dominio'),
      description: _t('Documento per gestire il cambio di registrante di un dominio da inviarci compilato in tutte le sue parti e firmato.'),
      link: 'https://files.artera.net/s/dysorb5n3ywKo5L',
    });
  } else if (login.fatturante.strid === 'see') {
    billing.push({
      name: _t('FACSIMILE - Cambio azienda di fatturazione di un servizio'),
      description: _t(
        "Facsimile del documento di cambio fatturazione dei servizi. Necessitiamo di ricevere un documento analogo a questo, scritto su carta intestata dell'azienda attualmente intestataria dei servizi e firmato dai due rappresentati legali delle aziende coinvolte",
      ),
      link: 'https://files.artera.net/s/okZGrJpEinrRg2P',
    });
  }

  return billing;
});

const partner = computed(() => {
  if (login.is_reseller) {
    return [
      {
        name: _t('Partner program'),
        description: _t('Scopri tutti i dettagli del nostro programma partner, con i vantaggi e le condizioni riservate ai rivenditori Artera.'),
        link: login.lingua === 'it' ? 'https://files.artera.net/s/Ed3YeK9B5N3yXyi' : 'https://files.artera.net/s/gYTkbWEaMKz9HmG',
      },
    ];
  }

  return [];
});

const other = computed(() => {
  const other: Document[] = [];

  if (login.fatturante.strid === 'dhh') {
    other.push({
      name: _t('DPA - Accordo aggiuntivo per la protezione dei dati personali'),
      description: _t('Il documento che regola il trattamento dei dati personali dei servizi Artera che ci deve essere inviato, compilato e firmato'),
      link: 'https://files.artera.net/s/X6Gb3AzrZ8rSSSn',
    });

    other.push({
      name: _t('NDA - Accordo di riservatezza'),
      description: _t('Il documento che regola lo scambio di informazioni riservate che ci deve essere inviato, compilato e firmato'),
      link: 'https://files.artera.net/s/X6b2dMPgxqYsoJz',
    });
  }

  return other;
});

const contracts = computed(() => {
  const contracts: Document[] = [];

  if (login.contratto_cliente) {
    contracts.push({
      name: _t('Termini e condizioni'),
      description: _t('Le condizioni generali della nostra fornitura. '),
      contract: 'cliente',
    });
  }

  if (login.is_reseller) {
    contracts.push({
      name: _t('Contratto partner'),
      description: _t('Le condizioni a te riservate in quanto partner.'),
      contract: 'rivenditore',
    });
  }

  return contracts;
});
</script>
